module.exports = __webpack_public_path__ + "static/media/server-network.b25e19fa.svg";